import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    agreement: {
        id: 'card.agreement',
        defaultMessage: 'Offer Agreement',
    },
    button: {
        id: 'card.button',
        defaultMessage: 'Choose this card',
    },
    details: {
        id: 'card.details',
        defaultMessage: 'Details',
    },
    close: {
        id: 'card.close',
        defaultMessage: 'Close',
    },
    choose: {
        id: 'card.choose',
        defaultMessage: 'Choose',
    },
    addInfo: {
        id: 'card.additional_info',
        defaultMessage: 'Additional info:',
    },
})
